import { IconWrapper } from '../runtime';
export default IconWrapper('folder_private_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1.5 13.5C0.671573 13.5 0 12.8284 0 12L0 1.5C0 0.671573 0.671573 0 1.5 0L4.5 0C4.82456 0 5.14036 0.105267 5.4 0.3L6.6 1.2C6.85964 1.39473 7.17544 1.5 7.5 1.5L14.5 1.5C15.3284 1.5 16 2.17157 16 3L16 12C16 12.8284 15.3284 13.5 14.5 13.5L1.5 13.5Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.5 15C0.671573 15 0 14.3284 0 13.5L0 4.5C0 3.67157 0.671573 3 1.5 3L14.5 3C15.3284 3 16 3.67157 16 4.5L16 13.5C16 14.3284 15.3284 15 14.5 15L1.5 15Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 5C6.89543 5 6 5.89543 6 7V8H5V12H11V8H10V7C10 5.89543 9.10457 5 8 5ZM9 7V8H7V7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7Z",
      "fill": "white"
    }
  })]);
});